import { render, staticRenderFns } from "./IncidentReportMediaSelector.vue?vue&type=template&id=000a1529&scoped=true"
import script from "./IncidentReportMediaSelector.vue?vue&type=script&lang=js"
export * from "./IncidentReportMediaSelector.vue?vue&type=script&lang=js"
import style0 from "./IncidentReportMediaSelector.vue?vue&type=style&index=0&id=000a1529&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000a1529",
  null
  
)

export default component.exports